import { render, staticRenderFns } from "./pca.vue?vue&type=template&id=af2b13ba&scoped=true&"
import script from "./pca.vue?vue&type=script&lang=js&"
export * from "./pca.vue?vue&type=script&lang=js&"
import style0 from "./pca.vue?vue&type=style&index=0&id=af2b13ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2b13ba",
  null
  
)

export default component.exports